export const v3Schema = {
    type: "object",
    properties: {
        edge_device_id: {
            type: "integer",
            readOnly: true,
        },
        config_version_no: {
            type: "integer",
        },
        low_power_mode: {
            type: "string",
            enum: ["on", "off"],
        },
        operation_mode: {
            type: "string",
            enum: ["normal", "burn"],
        },
        priority_group: {
            type: "integer",
        },
        os1_lidar: {
            type: "object",
            properties: {
                azimuth_window_start: {
                    type: "integer",
                    minimum: 140,
                    maximum: 210,
                },
                azimuth_window_end: {
                    type: "integer",
                    minimum: 150,
                    maximum: 220,
                },
                frame_count: {
                    type: "integer",
                    minimum: 0,
                    maximum: 50,
                },
                scan_type: {
                    type: "integer",
                    "enum": [
                        0,
                        1,
                    ],
                },
            },
            required: ["azimuth_window_start", "azimuth_window_end", "frame_count", "scan_type"],
        },
        vlp_parameters: {
            type: "object",
            properties: {
                vlp16_ip_address: {
                    type: "string",
                },
                motorSpeed: {
                    type: "integer",
                },
                udp_timeout: {
                    type: "integer",
                },
                preheat_interval: {
                    type: "integer",
                    "enum": [
                        35,
                        60,
                        120,
                        180,
                        240,
                        300
                    ],
                },
                postscan_interval: {
                    type: "integer",
                },
            },
            required: ["vlp16_ip_address", "motorSpeed", "udp_timeout", "preheat_interval", "postscan_interval"],
        },
        server_settings: {
            type: "object",
            properties: {
                server_url: {
                    type: "string",
                    enum: [
                        "https://devices.linevisioninc.com/v3_dev",
                        "https://dev-vpg-devices.linevisioninc.com",
                        "https://devices.linevisioninc.com/v3.0.1",
                        "https://devices.linevisioninc.com/v3.0.2",
                        "https://prod-vpg-devices.linevisioninc.com",
                        "https://devices.linevision.co/v3_dev",
                        "https://devices.linevision.co/v3.0.1",
                        "https://devices.linevision.co/v3.0.2",
                    ],
                },
                server_contact_interval: {
                    type: "integer",
                },
                server_contact_interval_offset: {
                    type: "integer",
                    readOnly: true,
                },
                output_zipfile: {
                    type: "integer",
                },
            },
            required: ["server_url", "server_contact_interval", "server_contact_interval_offset", "output_zipfile"],
        },
        scan_settings: {
            type: "object",
            properties: {
                compressed_scan_interval: {
                    type: "integer",
                    "enum": [
                        120,
                        240,
                        300,
                        420,
                        600,
                        900,
                        1800,
                        3600
                    ],
                },
                compressed_scan_interval_offset: {
                    type: "integer",
                },

                numUDP: {
                    type: "integer",
                    "enum": [
                        500,
                        750,
                        1000,
                        1250,
                        1500,
                        2500,
                        5000
                    ],
                },
                pointCountMax: {
                    type: "integer",
                },
                azRange: {
                    type: "array",
                    range_min: 0,
                    range_max: 359,
                    ensure_ordered: false,
                    maxItems: 2,
                    items: {
                        type: "integer",
                        minimum: 0,
                        maximum: 359,
                    },
                },
                elevRange: {
                    type: "array",
                    maxItems: 2,
                    range_min: -25,
                    range_max: 23,
                    items: {
                        type: "integer",
                        minimum: -25,
                        maximum: 23,
                    },
                },
                radiusRange: {
                    type: "array",
                    maxItems: 2,

                    range_min: 0,
                    range_max: 100,
                    items: { type: "integer", minimum: 0, maximum: 100 },
                },
                x_range: {
                    type: "array",
                    maxItems: 2,
                    range_min: -100,
                    range_max: 100,
                    items: { type: "integer", minimum: -100, maximum: 100 },
                },
                y_range: {
                    type: "array",
                    maxItems: 2,
                    range_min: -100,
                    range_max: 100,
                    items: { type: "integer", minimum: -100, maximum: 100 },
                },
                z_range: {
                    type: "array",
                    range_min: -100,
                    range_max: 100,
                    maxItems: 2,
                    items: { type: "integer", minimum: -100, maximum: 100 },
                },
            },
            required: [
                "algorithm_list",
                "compressed_scan_interval",
                "compressed_scan_interval_offset",
                "numUDP",
                "maxUDP",
                "pointCountMax",
                "azRange",
                "elevRange",
                "radiusRange",
                "x_range",
                "y_range",
                "z_range",
            ],
        },
        "compressed_scan_settings": {
            "type": "object",
            "properties": {
                "cubeEdge_m": {
                    "type": "number",
                    "enum": [
                        0.02,
                        0.22
                    ]
                }
            },
            "required": ["cubeEdge_m"]
        },
        conductor_fit_settings: {
            type: "object",
            properties: {
                conductor_target_array: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            conductor_id: {
                                type: "integer",
                            },
                            cylMean: {
                                type: "array",
                                maxItems: 3,
                                items: {
                                    type: "integer",
                                },
                            },
                            cylAxis: {
                                type: "array",
                                maxItems: 3,
                                items: {
                                    type: "integer",
                                },
                            },
                            cylRadm: {
                                type: "array",
                                maxItems: 1,
                                items: {
                                    type: "integer",
                                },
                            },
                            cylProj: {
                                type: "array",
                                maxItems: 2,
                                items: {
                                    type: "integer",
                                },
                            },
                            search_range_x: {
                                type: "array",
                                maxItems: 2,
                                items: {
                                    type: ["integer", "null"],
                                },
                            },
                            search_range_y: {
                                type: "array",
                                maxItems: 2,
                                items: {
                                    type: ["integer", "null"],
                                },
                            },
                            search_range_z: {
                                type: "array",
                                maxItems: 2,
                                items: {
                                    type: ["integer", "null"],
                                },
                            },
                            numPtsConductor: {
                                type: "integer",
                            },
                        },
                        required: [
                            "conductor_id",
                            "cylMean",
                            "cylAxis",
                            "cylRadm",
                            "cylProj",
                            "search_range_x",
                            "search_range_y",
                            "search_range_z",
                            "numPtsConductor",
                        ],
                    },
                },
            },
            required: ["conductor_target_array"],
        },
    },
    required: [
        "edge_device_id",
        "config_version_no",
        "low_power_mode",
        "operation_mode",
        "vlp_parameters",
        "server_settings",
        "scan_settings",
        "compressed_scan_settings",
        "conductor_fit_settings",
    ],
};
